import React from "react";
import "./css/Footer.css";

const Footer = ({ onNavigate }) => {
  return (
    <footer className="footer">
      <div className="footer-content">
        
        <div className="footer-brand">
          <img src="/vyral.png" alt="Vyral Logo" className="footer-logo" />
          <span className="footer-brand-name">Vyral Media Group</span>
          <p className="footer-tagline">Building the future of social media and entertainment</p>
        </div>

        <div className="footer-nav">
          <h4>Navigation</h4>
          <ul>
            <li><span className="footer-link" onClick={() => onNavigate("home")}>Home</span></li>
            <li><span className="footer-link" onClick={() => onNavigate("products")}>Products</span></li>
            <li><span className="footer-link" onClick={() => onNavigate("divisions")}>Divisions</span></li>
            <li><span className="footer-link" onClick={() => onNavigate("about")}>About</span></li>
            <li><span className="footer-link" onClick={() => onNavigate("employment")}>Careers</span></li>
            <li><span className="footer-link" onClick={() => onNavigate("contact")}>Contact</span></li>
          </ul>
        </div>

        <div className="footer-legal">
          <h4>Legal</h4>
          <ul>
            <li><span className="footer-link" onClick={() => onNavigate("privacy")}>Privacy Policy</span></li>
            <li><span className="footer-link" onClick={() => onNavigate("terms")}>Terms of Service</span></li>
          </ul>
        </div>

        <div className="footer-social">
          <h4>Connect</h4>
          <div className="social-links">
            <a
              href="https://x.com/theofficialrpl"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Twitter"
              className="social-link"
            >
              <svg viewBox="0 0 24 24" fill="currentColor" width="20" height="20">
                <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/>
              </svg>
            </a>
            <a
              href="https://www.tiktok.com/@official.ripple"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="TikTok"
              className="social-link"
            >
              <svg viewBox="0 0 24 24" fill="currentColor" width="20" height="20">
                <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5 20.1a6.34 6.34 0 0 0 10.86-4.43v-7a8.16 8.16 0 0 0 4.77 1.52v-3.4a4.85 4.85 0 0 1-1-.1z"/>
              </svg>
            </a>
          </div>
          <p className="footer-email">
            <a href="mailto:info@vyralmediagroup.com" className="footer-link">info@vyralmediagroup.com</a>
          </p>
        </div>

      </div>

      <div className="footer-bottom">
        <p>
          © {new Date().getFullYear()}{" "}
          <a
            href="https://vyralmediagroup.com"
            target="_blank"
            rel="noopener noreferrer"
          >
            Vyral Media Group
          </a>
          . All rights reserved.
        </p>
      </div>
    </footer>
  );
};

export default Footer;
